import Script from 'next/script';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { fireImpactPageView } from 'tracking/utils/impactEvents';
import { IAuth } from 'store/types/authTypes';
import { useStoreSelector } from 'store/hooks/storeHooks';

declare global {
  interface Window {
    ire: any;
  }
}

interface IImpactScriptProps {
  cspNonce: string;
  isOneTrustEnabled: boolean;
}

export const ImpactScript = ({ cspNonce, isOneTrustEnabled }: IImpactScriptProps) => {
  const { user }: IAuth = useStoreSelector((state) => state.auth);
  const router = useRouter();
  const [initialPageView, setInitialPageView] = useState(false);

  const fireInitialPageView = (retry = 3) => {
    if (initialPageView) return;

    if (!window?.ire && retry > 0) {
      setTimeout(() => {
        fireInitialPageView(retry - 1);
      }, 1000 * 2 ** (5 - retry));

      return;
    }

    setInitialPageView(true);
    void fireImpactPageView({ id: user?.id, email: user?.email });
  };

  useEffect(() => {
    router.events.on('routeChangeComplete', () =>
      fireImpactPageView({ id: user?.id, email: user?.email }),
    );

    return () => {
      router.events.off('routeChangeComplete', () =>
        fireImpactPageView({ id: user?.id, email: user?.email }),
      );
    };
  }, [router.events]);

  return (
    <Script
      className="optanon-category-C0004"
      id="impact-script-1"
      key="impact"
      nonce={cspNonce}
      strategy="lazyOnload"
      type={isOneTrustEnabled ? 'text/plain' : 'text/javascript'}
      onReady={fireInitialPageView}
    >
      {`
        (function(a, b, c, d, e, f, g) {
          e['ire_o'] = c;
          e[c] = e[c] || function() {
            (e[c].a = e[c].a || []).push(arguments)
          };
          f = d.createElement(b);
          g = d.getElementsByTagName(b)[0];
          f.async = 1;
          f.src = a;
          g.parentNode.insertBefore(f, g);
        })('https://d.impactradius-event.com/A2531724-4768-4093-a3f8-41213520467b1.js', 'script', 'ire', document, window);
      `}
    </Script>
  );
};
